/* Site wide navigation JS helpers for animation, nav menu. */

/*
  Percent of element needed to be visible in viewport for intersection
  observer to trigger callback to indicate element is visible.
*/
const INTERSECTION_THRESHOLD = 0.5;

// Options for IntersectionObserver to detect when element is in view.
const INTERSECTION_OPTIONS = {
  root: null, // Browser's viewport
  threshold: INTERSECTION_THRESHOLD,
};

/* Add animation for elements if IntersectionObserver is supported. */
if ('IntersectionObserver' in window && document.querySelectorAll('.animate').length) {
  // Callback called when observed target element is in view beyond threshold.
  const animateCallback = function (entries) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const targetElement = entry.target;
      // Use the animate class set on data attribute or fall back to fade in.
      const animateClass = targetElement.dataset.animateClass || 'animate__fade-in';
      if (entry.intersectionRatio > INTERSECTION_THRESHOLD) {
        // Do not add animation if object has already been animated.
        if (targetElement.classList.contains(animateClass)) {
          return animateObserver.unobserve(targetElement);
        }
        targetElement.classList.add(animateClass);
        targetElement.classList.remove('animate__invisible');
      }
    }
  };
  // Observe all elements all page with .animate CSS selector set.
  const animateObserver = new IntersectionObserver(animateCallback, INTERSECTION_OPTIONS);
  document.querySelectorAll('.animate').forEach((target) => {
    // Initialize all elements to be invisible as initial state.
    target.classList.add('animate__invisible');
    animateObserver.observe(target);
  });
}

// Expand and collapse top nav dropdown menu, hamburger menu for mobile devices.
const menuButton = document.getElementById('menu-button');
if (menuButton) {
  const dropDownContents = document.querySelectorAll('.dropdown-content');
  let activeDropDownContent;
  const collapseAllDropDownContent = function () {
    dropDownContents.forEach((dropDownContent) => {
      if (dropDownContent !== activeDropDownContent) {
        dropDownContent.classList.remove('dropdown-content--clicked');
      }
    });
  };

  /* BurgerMenu will collapse if clicked, using CSS input:checked selector
     This logic is to collapse BurgerMenu when clicked outside of the header. */
  const headerElement = document.getElementById('js-header');
  const collapseBurgerMenu = function (event) {
    if (!menuButton.checked || !headerElement) {
      return;
    }
    if (!headerElement.contains(event.target)) {
      menuButton.checked = false;
      collapseAllDropDownContent();
    }
  };

  /* On iOS devices, a click event is triggered only when an
  element has cursor: pointer or inline attribute onClick
  Tracking touch events and making sure it is not a swipe action */
  let touchMoveActive;
  document.addEventListener('touchend', function (event) {
    if (!touchMoveActive) {
      collapseBurgerMenu(event);
    }
  });
  // If touchmove event is triggered, that means swipe action.
  document.addEventListener('touchmove', function () {
    touchMoveActive = true;
  });
  document.addEventListener('touchstart', function () {
    touchMoveActive = false;
  });
  // Some browsers don't support touch events, so fall back to click event.
  document.addEventListener('click', function (event) {
    collapseBurgerMenu(event);
  });

  const menu = document.getElementById('js-menu');
  if (menu) {
    menu.addEventListener('click', function (event) {
      if (event.target.className === 'dropdown') {
        const icon = event.target.querySelector('.icon');
        if (icon) {
          const chevronPath = icon.querySelector('.js-chevron-path');
          // If the Chevron SVG is facing down, then change to facing up and add color-frisbee to
          // indicate that the dropdown menu is being shown.
          // eslint-disable-next-line max-len
          if (
            chevronPath.getAttribute('d') ===
            'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z'
          ) {
            chevronPath.setAttribute('d', 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z');
            icon.parentNode.classList.add('color-frisbee');
          } else {
            chevronPath.setAttribute('d', 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z');
            icon.parentNode.classList.remove('color-frisbee');
          }
        }
        activeDropDownContent = event.target.querySelector('.dropdown-content');
        activeDropDownContent.classList.toggle('dropdown-content--clicked');
        collapseAllDropDownContent();
      }
    });
  }
}

// Automatically cycle between pet and recipe images in homepage hero.
const homeQuoteCycler = document.querySelector('.home-quote-cycler');
if (homeQuoteCycler) {
  const textCycler = (textCyclerEl, texts) => {
    const maxIndex = texts.length;
    let index = 0;
    // Automatically cycle between images every half second.
    setInterval(() => {
      if (index === maxIndex) {
        index = 0;
      }
      textCyclerEl.textContent = texts[index];
      index++;
    }, 1500);
  };
  const quotes = [
    '“My dog jumps with excitement at meal time.”',
    '“I wish we switched sooner. This was the best decision.”',
    '“Our vet was amazed and all we did was change his food.”',
    '“Finley jumps in circles when it’s meal time.”',
    '“I trust that it’s healthy and fresh with each delivery!”',
  ];
  textCycler(homeQuoteCycler, quotes);
}
